module.exports = __webpack_public_path__ + "static/media/rome-1.2ed35b84.jpg";